import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#FFC700] mb-4">{children}</p>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight text-[#F9FAFB] ${className}`}>
    {children}
  </h2>
);
